import { Add, AddToPhotos, Delete } from '@mui/icons-material';
import { Col, Progress, Row } from 'antd';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { FileUploader } from "react-drag-drop-files";
import styled from 'styled-components';
import COLOR from "utils/constants/color";
import ModalMenu from "components/Modals";
import { Button, Snackbar, CircularProgress } from '@mui/material';
import { Alert } from '@mui/material';
import { getSizeInKBMb } from "utils/methods/math";
import { useCurrentUser } from "store/users/selectors";
import * as Sentry from '@sentry/react';
import { get } from "lodash";
import MultiFileUploader from "components/UI/admin/MultifileUploadGallery";
import { IMAGE_FILE_TYPE } from 'utils/constants/enum';
import { uploadFileToCloudflare, deleteImageFromCloudflare } from "utils/methods/cloudflareUploadeImage";

const MAX_FILE_SIZE = 10 * 1024 * 1024;

const ImageContainer = styled.div`
    height: auto;
    flex: 1;
    margin-bottom: 10px;

    @media (max-width: 600px){
       height: 400px !important;
    }
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    // box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    border-radius:8px;

    @media (min-width: 1024px) {
        max-height: 160px;
        max-width: 80%;
    }

     @media (max-width: 1024px) {
        max-height: 110px!important;
     }

`;
const Container = styled.div`
    width: 100%;
    min-height: 10vh;
    display:flex;
    flex-direction: column;
    align-items:flex-start;
    justify-content:center;
    position: relative;
    background-color:${p => p.empty ? "rgba(0,0,0,0.1)" : "transparent"}
`;


const ImageWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin: 10px 0;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ImageItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
`;

const DeleteIcon = styled(Delete)`
  position: absolute;
  top: 6px;
  right: 2px;
  font-size: 30px;
  cursor: pointer;
  color: red;
  background-color: white;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  z-index: 10;
`;

const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Text = styled.div`
    font-size: 12px;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
`;
export default function PictureAssignment({source, handlePicture, additionalImages: propAdditionalImages = [], handleAdditionalPictures, path, type , style={}, disabled=false, maxImagesUpload=6, imageClassName = "",  containerClassName="",setButtonDisabled = (val)=> {} , showImagePicker, isNewSubmission, from='', showResponsePreview=true }) {
    const currentUser = useCurrentUser()
    const [loader, setLoader] = useState(false);
    const [loadingMap, setLoadingMap] = useState(0);
    const [showAdditionalUploaders, setShowAdditionalUploaders] = useState({});
    const [additionalLoaders, setAdditionalLoaders] = useState({});
    const [additionalLoadingMaps, setAdditionalLoadingMaps] = useState({});
    const [selectedImageForModal, setSelectedImageForModal] = useState(null);
    const prevAdditionalImagesRef = useRef({ source: null, propAdditionalImages: null });
    const fileInputRef = useRef(null);
    const [uploadedImages, setUploadedImages] = useState([]);
    const[imageModal,setImageModal] = useState(false);
    const [deletingImageIndex, setDeletingImageIndex] = useState(null);
    const [alert, setAlert] = useState({
        open: false,
        message: "",
      });
      const isPreviewStudent = useMemo(() => {
        return from === 'shareAssignment' && currentUser?.role === "student"
      }, [from, currentUser])

    const deleteImageFromStorage = async (imageUrl) => {
        if (!imageUrl) {
            return;
        }
        try {
            await deleteImageFromCloudflare(imageUrl);
        } catch (error) {
            console.log(error);
            Sentry.captureException(`Error deleting image from Cloudflare: ${error}`);
        }
    };

    useEffect(() => {
        const prevSource = prevAdditionalImagesRef.current.source;
        const prevPropAdditionalImages = prevAdditionalImagesRef.current.propAdditionalImages;
        const sourceChanged = prevSource !== source;
        const additionalImagesChanged = JSON.stringify(prevPropAdditionalImages) !== JSON.stringify(propAdditionalImages);
        
        if (!sourceChanged && !additionalImagesChanged) {
            return;
        }
        
        const newImages = [];
        if (source) {
            newImages[0] = source;
        } else {
            newImages[0] = undefined;
        }
        if (Array.isArray(propAdditionalImages) && propAdditionalImages.length > 0) {
            propAdditionalImages.forEach((img, index) => {
                if (img) {
                    newImages[index + 1] = img;
                }
            });
        } else if (sourceChanged && !source) {
            setUploadedImages(prev => {
                const currentAdditionalImages = prev.slice(1).filter(img => img);
                if (currentAdditionalImages.length > 0) {
                    const preservedImages = [undefined, ...currentAdditionalImages];
                    return preservedImages;
                }
                return newImages;
            });
            prevAdditionalImagesRef.current = { source, propAdditionalImages };
            return;
        }
        setUploadedImages(newImages);
        prevAdditionalImagesRef.current = { source, propAdditionalImages };
    }, [source, propAdditionalImages])


    const uploadToStorage = async (file, imageIndex = null) => {
        if(disabled){
            return;
        }
        if (file) {
            const fileType = file.type || '';
            const fileExtension = file.name?.split('.').pop()?.toUpperCase() || '';
            const isValidImageType = fileType.startsWith('image/') || IMAGE_FILE_TYPE.includes(fileExtension);
            
            if (!isValidImageType) {
                setAlert({
                    open: true,
                    message: `Only image files are allowed. Please upload JPG, PNG, JPEG, or WEBP files only.`,
                });
                return;
            }
            const totalImages = uploadedImages.filter(img => img).length;
            if (totalImages >= maxImagesUpload) {
                setAlert({
                    open: true,
                    message: `Maximum ${maxImagesUpload} images allowed. Please delete an image before uploading a new one.`,
                });
                return;
            }
            if (file.size > MAX_FILE_SIZE &&  get(currentUser, "role") !== "owe_admin" ) {
                setAlert({
                    open: true,
                    message: `Your file size(${getSizeInKBMb(file?.size)}) exceeds the maximum limit of 10MB.`,
                  });
                return;
            }
            setButtonDisabled(true)
    
    try {
                            const onProgress = (progress) => {
           const per = Math.round(progress);
                        if(imageIndex !== null) {
                            setAdditionalLoadingMaps(prev => ({ ...prev, [imageIndex]: per }));
                            setAdditionalLoaders(prev => ({ ...prev, [imageIndex]: true }));
                        } else {
                            setLoadingMap(per);
                            setLoader(true);
                        }
                        if(setButtonDisabled){
                            setButtonDisabled(true);
                        }
           };
            
                            const downloadURL = await uploadFileToCloudflare(file, onProgress);
                            if(imageIndex !== null) {
                                setAdditionalLoaders(prev => ({ ...prev, [imageIndex]: false }));
                                setAdditionalLoadingMaps(prev => ({ ...prev, [imageIndex]: 0 }));
                                setUploadedImages(prev => {
                                    const newImages = [...prev];
                                    if (newImages.length === 0 || imageIndex >= newImages.length) {
                                        if (newImages.length === 0) {
                                            newImages[0] = undefined;
                                        }
                                        while (newImages.length <= imageIndex) {
                                            newImages.push(undefined);
                                        }
                                    }
                                    newImages[imageIndex] = downloadURL;
                                    const additionalImagesArray = newImages.slice(1).filter(img => img);
                                    if(handleAdditionalPictures) {
                                        handleAdditionalPictures(additionalImagesArray);
                                    }
                                    return newImages;
                                });
                                setShowAdditionalUploaders(prev => {
                                    const updated = { ...prev };
                                    delete updated[imageIndex];
                                    return updated;
                                });
                            } else {
                                setLoader(false);
                                setLoadingMap(0);
                                setUploadedImages(prev => {
                                    const newImages = [...prev];
                                    const oldMainImage = newImages[0];
                                    if (oldMainImage) {
                                        if (isNewSubmission) {
                                            deleteImageFromStorage(oldMainImage);
                                        }
                                        newImages[0] = downloadURL;
                                    } else {
                                        newImages[0] = downloadURL;
                                    }
                                    return newImages;
                                });
                                if(handlePicture) {
                                    handlePicture(downloadURL);
                                }
                            }
                            if(setButtonDisabled){
                                setButtonDisabled(false);
                            }
            } catch (error) {
                Sentry.captureException(`369 Upload error: ${error}`);
                if(imageIndex !== null) {
                    setAdditionalLoaders(prev => ({ ...prev, [imageIndex]: false }));
                    setAdditionalLoadingMaps(prev => ({ ...prev, [imageIndex]: 0 }));
                } else {
                    setLoader(false);
                    setLoadingMap(0);
                }
                setButtonDisabled(false);
            }
            finally{
                if(setButtonDisabled){
                    setButtonDisabled(false);
                } 
            }
        } else {
            console.log("No file to upload.");
        }
    };

    const handleCloseAlert = () => {
        setAlert({
          open: false,
          message: "",
        });
      };
    const onSelectImage = (url) => {
        setLoader(false);
        setLoadingMap(0);
        setUploadedImages(prev => {
            const newImages = [...prev];
            newImages[0] = url;
            return newImages;
        });
        handlePicture(url);
    }

    const shiftStateObject = (stateObj, deletedIndex) => {
        const shifted = {};
        Object.keys(stateObj).forEach(key => {
            const keyNum = parseInt(key);
            if (keyNum > deletedIndex) {
                shifted[keyNum - 1] = stateObj[key];
            } else if (keyNum !== deletedIndex) {
                shifted[keyNum] = stateObj[key];
            }
        });
        return shifted;
    };

    const handleDeleteUploadedImages = async (index) => {
        const imageUrlToDelete = uploadedImages[index];
        setDeletingImageIndex(index);
        
        try {
            if (isNewSubmission && imageUrlToDelete) {
                await deleteImageFromStorage(imageUrlToDelete);
            }
        } catch (error) {
            setDeletingImageIndex(null); 
            return;
        }
        let updatedImages;
        if (index === 0) {
            updatedImages = uploadedImages.filter((_, i) => i !== 0);
            const newMainImage = updatedImages[0];
            if(handlePicture) {
                handlePicture(newMainImage || null);
            }
        } else {
            updatedImages = uploadedImages.filter((_, i) => i !== index);
        }
        setUploadedImages(updatedImages);
        const additionalImagesArray = updatedImages.slice(1).filter(img => img);
        if(handleAdditionalPictures) {
            handleAdditionalPictures(additionalImagesArray);
        }
        const updatedLoaders = { ...additionalLoaders };
        const updatedMaps = { ...additionalLoadingMaps };
        const updatedUploaders = { ...showAdditionalUploaders };
        
        if (index === 0) {
            delete updatedLoaders[0];
            delete updatedMaps[0];
            delete updatedUploaders[0];
            const shiftedLoaders = shiftStateObject(updatedLoaders, 0);
            const shiftedMaps = shiftStateObject(updatedMaps, 0);
            const shiftedUploaders = shiftStateObject(updatedUploaders, 0);
            setAdditionalLoaders(shiftedLoaders);
            setAdditionalLoadingMaps(shiftedMaps);
            setShowAdditionalUploaders(shiftedUploaders);
        } else {
            delete updatedLoaders[index];
            delete updatedMaps[index];
            delete updatedUploaders[index];
            
            setAdditionalLoaders(shiftStateObject(updatedLoaders, index));
            setAdditionalLoadingMaps(shiftStateObject(updatedMaps, index));
            setShowAdditionalUploaders(shiftStateObject(updatedUploaders, index));
        }
        setDeletingImageIndex(null);
    }

    const filteredImagesCount = uploadedImages.filter(img => img).length;
    const handleAddMoreClick = () => {
        if (filteredImagesCount >= maxImagesUpload) {
            return;
        }
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    const handleFileInputChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            const fileType = file.type || '';
            const fileExtension = file.name?.split('.').pop()?.toUpperCase() || '';
            const isValidImageType = fileType.startsWith('image/') || IMAGE_FILE_TYPE.includes(fileExtension);
            
            if (!isValidImageType) {
                setAlert({
                    open: true,
                    message: `Only image files are allowed. Please upload JPG, PNG, JPEG, or WEBP files only.`,
                });
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
                return;
            }
            let nextIndex = uploadedImages.length;
            for (let i = 1; i < uploadedImages.length; i++) {
                if (!uploadedImages[i]) {
                    nextIndex = i;
                    break;
                }
            }
            uploadToStorage(file, nextIndex);
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }

    const handleOpenImageModal = (imageUrl) => {
        setSelectedImageForModal(imageUrl);
        setImageModal(true);
    }
    return (
        <>
        <ModalMenu type="imageModal" image={selectedImageForModal || uploadedImages[0]} open={imageModal} close={() => setImageModal(false)}  />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={alert.open}
          autoHideDuration={5000}
          onClose={handleCloseAlert}
        >
        <Alert onClose={handleCloseAlert} severity="error">
          <strong>ALERT:</strong> {alert.message}
        </Alert>
      </Snackbar>
      <ImageContainer className={containerClassName}  onContextMenu={(e) => { }} style={style}>
            <input
                ref={fileInputRef}
                type="file"
                accept={IMAGE_FILE_TYPE.join(",")}
                style={{ display: 'none' }}
                onChange={handleFileInputChange}
                disabled={disabled}
            />
            <Container className={`pictureAssign ${get(currentUser, "role") === "owe_admin" ? "pictureAssignAdmin" : "pictureAssign"}`}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> 
                {showImagePicker? <MultiFileUploader inModal onSelect={onSelectImage} />:null}
                </div>
                {filteredImagesCount === 0 && (<ImageItemContainer className='pictureAssignInr'>
               
                    <div style={{ width: '100%', marginTop: uploadedImages[0] ? 10 : 0 }}>
                        <FileUploader
                            classes={"imageFileUploader"}
                            handleChange={(file) => uploadToStorage(file, null)}
                            name="file"
                            disabled={disabled || loader}
                            types={IMAGE_FILE_TYPE}
                        >
                            <FileUploadArea style={{cursor: disabled || loader ? "default" : "pointer"}}>
                                {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                                <Row className="box box-1" style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Column >
                                        <AddToPhotos color="primary" />
                                    </Column>
                                    <Column>
                                        <Text>
                                            Upload or drop a file right here
                                        </Text>
                                    </Column>
                                    <Column>
                                        <Text>
                                            {IMAGE_FILE_TYPE.join(",")}
                                        </Text>
                                    </Column>
                                </Row>
                            </FileUploadArea>
                        </FileUploader>
                    </div>
                </ImageItemContainer>)}

                {/* TO SHOW ADDITIONAL IMAGES */}
                {uploadedImages.map((imageUrl, index) => {
                    if (!imageUrl) return null;
                    const isDeleting = deletingImageIndex === index;      
                    return (
                        <ImageItemContainer key={index} className='pictureAssignInrImage'>
                            <ImageWrapper style={{ position: 'relative' }}>
                                <Images 
                                    src={imageUrl} 
                                    className={`cursor-zoomIn showUploadImgCstm ${imageClassName}`}
                                    onClick={()=> !isDeleting && handleOpenImageModal(imageUrl)}
                                    style={{ 
                                        opacity: isDeleting ? 0.5 : 1,
                                        pointerEvents: isDeleting ? 'none' : 'auto'
                                    }}
                                />
                                {isDeleting && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 10,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <CircularProgress size={15} />
                                    </div>
                                )}
                            </ImageWrapper>
                            {!isPreviewStudent && (
                                   <div className="deltUploadImg">
                                <div 
                                    style={{
                                        display: 'flex', 
                                        alignItems: 'center',
                                        cursor: isDeleting ? 'not-allowed' : 'pointer',
                                    }} 
                                    onClick={() => !isDeleting && handleDeleteUploadedImages(index)}
                                > 
                                    <DeleteIcon/>
                                    <label>Delete</label>
                                </div>
                            </div>
                            )}
                        </ImageItemContainer>
                    );
                })}


                {/* TO SHOW ADD MORE IMAGES BUTTON */}
                {/* Owe Admin (currentUser.role === 'OWE_ADMIN') can only upload SINGLE image. */}
                {((filteredImagesCount !=0 && filteredImagesCount < maxImagesUpload )&& (get(currentUser, "role") !== "owe_admin")) && (
                    <ImageItemContainer>
                        <Button
                            variant="contained"
                            style={{ marginTop: 10 }}
                            color="primary"
                            startIcon={<Add />}
                            onClick={handleAddMoreClick}
                            disabled={disabled || additionalLoaders[uploadedImages.length]}
                        >
                            Add more images
                        {additionalLoaders[uploadedImages.length] && (
                            <CircularProgress size={20} style={{ marginLeft: 10 }} />
                        )}
                        </Button>
                    </ImageItemContainer>
                )}
            </Container>
        </ImageContainer>
        </>
    )
}